import type { GenericPipeItem } from 'valibot'
import type { NormalizedComponents } from '~/utils/crystallize/component-utils'
import { literal, object } from 'valibot'
import { baseCatalogueSchema } from '~/utils/crystallize/catalogue'
import { components } from '~/utils/crystallize/component-schemas'

/**
 * Schema for Crystallize documents. Will differ between the different document types, and should be extended for each use case.
 *
 * @see https://crystallize.com/learn/concepts/pim/document
 */
export function crystallizeDocumentSchema<
  const TShape extends string,
  TOutput,
  TComponents extends GenericPipeItem<NormalizedComponents, TOutput>,
>(shape: TShape, componentsSchema: TComponents) {
  return object({
    ...baseCatalogueSchema.entries,
    type: literal('document'),
    shape: object({
      identifier: literal(shape),
    }),
    components: components(componentsSchema),
  })
}
